import { render, staticRenderFns } from "./ApiView.vue?vue&type=template&id=ba1d53a6&scoped=true"
import script from "./ApiView.vue?vue&type=script&lang=js"
export * from "./ApiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1d53a6",
  null
  
)

export default component.exports